import { render, staticRenderFns } from "./protocolDialog.vue?vue&type=template&id=e60dfbcc&scoped=true&"
import script from "./protocolDialog.vue?vue&type=script&lang=js&"
export * from "./protocolDialog.vue?vue&type=script&lang=js&"
import style0 from "./protocolDialog.vue?vue&type=style&index=0&id=e60dfbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60dfbcc",
  null
  
)

export default component.exports